import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TableHeadToolbar from "../../TableHeadToolbar";

const TableHeadActive = () => {
    const { blue200, blue100 } = colors;

    return (
        <div
            css={css({
                position: "sticky",
                top: "0",
                left: "0",
                width: "100%",
                boxSizing: "border-box",
                marginTop: "-42px",
                zIndex: "4",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                rowGap: "8px",
                background: blue100,
                borderTop: `1px solid ${blue200}`,
                borderBottom: `1px solid ${blue200}`,
                borderRadius: "unset",
                padding: "4px 24px 4px 16px"
            })}
        >
            <TableHeadToolbar />
        </div>
    );
};

export default TableHeadActive;
